import { useEffect, useRef } from "react";

/**
 * Tiny SVG sparkline. Pure SVG so we don't drag in a chart library for
 * a stat card.
 */
export function Sparkline({
  data,
  width = 80,
  height = 24,
  tone = "auto",
}: {
  data: number[];
  width?: number;
  height?: number;
  tone?: "up" | "down" | "auto";
}) {
  const ref = useRef<SVGSVGElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (el) el.style.display = data.length >= 2 ? "block" : "none";
  }, [data.length]);

  if (data.length < 2) return null;

  const min = Math.min(...data);
  const max = Math.max(...data);
  const span = max - min || 1;
  const stepX = width / (data.length - 1);
  const points = data
    .map((v, i) => `${(i * stepX).toFixed(1)},${(height - ((v - min) / span) * height).toFixed(1)}`)
    .join(" ");
  const color =
    tone === "up"
      ? "rgb(var(--term-up))"
      : tone === "down"
      ? "rgb(var(--term-down))"
      : data[data.length - 1] >= data[0]
      ? "rgb(var(--term-up))"
      : "rgb(var(--term-down))";
  return (
    <svg ref={ref} width={width} height={height} viewBox={`0 0 ${width} ${height}`} aria-hidden="true">
      <polyline points={points} fill="none" stroke={color} strokeWidth={1.5} strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}
